<!-- In Progress Status / Counter Offer -->
<ng-container *ngIf="!showVouchers && !(loanCard?.cardType === 3 || loanCard?.cardType === 9 || loanCard?.cardType === 10)">
  <div class="new-card primary status-card" *ngIf="loanCard?.cardType !== 15">
    <div class='info-icon' *ngIf='loanCard.cardInfo' (click)="toggleCardInfo('open')">
      <img src='/assets/images/ocd/info-icon.svg' title='Card Info' alt='Card Info' />
    </div>
    <div class="status-info-wrapper">
      <div class="loan-icon">
        <div class='img'
          [style.background-image]="'url(' + s3Url + '/logo-icons/' + (application.MerchantName | lowercase) + '-logo-icon.png)'">
        </div>
      </div>
      <div class="info-section">
        <h2 class="status-header">{{loanCard.headerText}}</h2>
        <div class="desc">
          <div class="loan-info primary">
            <span>{{loanCard.merchantName}}</span><span>{{loanCard.loanAmount | RupeeCurrencyPipe}}</span>
          </div>
          <div class="loan-info secondary">
            <span>{{loanCard.tenure}} months</span><span>at
              {{loanCard.emi | RupeeCurrencyPipe}} / m</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card-bottom-content">
      <div *ngIf="loanCard?.infoText">
        {{loanCard.infoText}}
      </div>
      <zest-progress [progress]="loanCard?.scale" [message]="loanCard?.progressMsg"
        *ngIf="loanCard?.scale && loanCard?.scale !== 0">
      </zest-progress>
      <div class="button-wrapper">
        <button id="cancel-loan" class="btn zest-btn secondary"
          (click)="toggleConfirmCancelLoan('open')">CANCEL</button>
        <button id="continue-loan" *ngIf="!(loanCard.cardType === 2 || loanCard.cardType === 6)"
          class="btn zest-btn primary" (click)="continueLoan()">CONTINUE</button>
        <button id="continue-loan" *ngIf="loanCard.cardType === 2 || loanCard.cardType === 6"
          class="btn zest-btn primary" (click)="toggleConfirmGetVoucher('open')">GET VOUCHER</button>
      </div>
    </div>
    <!-- <div class="edit-strip-wrapper" [class.show]="showUpsell">
      <div class="edit-strip upsell" (click)="toggleUpSellView('open')">
        <span class="title">Increase your voucher upto
          {{upsellAmount | RupeeCurrencyPipe}}</span>
        <i class="arrow material-icons">chevron_right</i>
      </div>
    </div> -->
    <div class="edit-strip-wrapper" [class.show]="loanCard.cardType === 11">
      <div class="edit-strip counter-offer" (click)="toggleCounterOfferView('open')">
        <span class="title">Edit your new voucher plan</span>
        <i class="arrow material-icons">chevron_right</i>
      </div>
    </div>
  </div>
  <div class="voucher-generation-success" *ngIf="loanCard?.cardType === 15">
    <div class="new-card primary status-card">
      <div class="status-info-wrapper">
        <div class="status-icon" [style.background-image]="'url(/assets/images/ocd/' + loanCard.name + '.png)'">
        </div>
        <div class="info-section">
          <h2 class="status-header">{{loanCard.headerText}}</h2>
          <div class="desc">{{loanCard.infoText}}</div>
        </div>
      </div>
    </div>
    <div class="fraud-disclaimer">
      <img src="/assets/images/ocd/information-icon.svg" alt="info icon">
      <div class="fraud-info-text">We are no longer displaying voucher codes on this page. They will be delivered straight to your registered email ID and WhatsApp.</div>
    </div>
  </div>
  <div class="new-card primary"
    *ngIf="(!(loanCard?.cardType === 2 || loanCard?.cardType === 6) && approvedApplications?.length >= 1) || approvedApplications?.length > 1">
    <div class="card-info">
      <h3>You've <span
          *ngIf="!(loanCard?.cardType === 2 || loanCard?.cardType === 6)">{{approvedApplications.length}}</span><span
          *ngIf="loanCard?.cardType === 2 || loanCard?.cardType === 6">{{approvedApplications.length - 1}} more</span>
        approved vouchers to be
        activated</h3>
    </div>
    <div class="footer-wrapper">
      <div class="loan-wrapper">
        <div class="loan-icons">
          <ng-container *ngFor="let gc of approvedApplications; let i=index">
            <div class="loan-icon" *ngIf="i < 3 && gc.ExternalId !== application.ApplicationId">
              <div class="img"
                [style.background-image]="'url(' + s3Url + '/logo-icons/' + (gc.MerchantName | lowercase) + '-logo-icon.png)'">
              </div>
            </div>
          </ng-container>
        </div>
        <div *ngIf="approvedApplications.length > 4"> +{{approvedApplications.length - 4}} more</div>
      </div>
      <button class="btn zest-btn outline view-loans" (click)="toggleAllLoansView('open')">VIEW</button>
    </div>
  </div>

  <!-- All Loan List -->
  <div id="all-loans" class="modal new-modal full-screen" [class.bottom-sheet]="!isDesktop" materialize="modal"
    [materializeParams]="[{dismissible: false}]">
    <zest-loan-list *ngIf="approvedApplications.length" [applications]="approvedApplications"
      (close)="toggleAllLoansView('close')" (cancel)="bulkCancel($event)" (generate)="bulkGenerate($event)">
    </zest-loan-list>
  </div>

  <!-- Up Sell View -->
  <div id="up-sell" class="modal new-modal full-screen" *ngIf="showUpsell" [class.bottom-sheet]="!isDesktop"
    [materializeParams]="[{dismissible: false}]" materialize="modal">
    <zest-update-loan [inView]='showUpdateView' [newAmount]="upsellAmount" [application]="application" [isUpSell]=true
      [headerText]="'Increase your voucher upto ' + (upsellAmount | RupeeCurrencyPipe)"
      (voucherUpdated)="continueUpsell($event)" (close)="toggleUpSellView('close')"></zest-update-loan>
  </div>

  <!-- Counter Offer View-->
  <div id="counter-offer" class="modal new-modal full-screen" *ngIf="loanCard.cardType === 11"
    [class.bottom-sheet]="!isDesktop" [materializeParams]="[{dismissible: false}]" materialize="modal">
    <zest-update-loan [inView]='showUpdateView' [newAmount]="counterOfferAmount" [application]="application"
      [headerText]="'Edit your new voucher plan'" (voucherUpdated)="continueCounterOffer($event)"
      (close)="toggleCounterOfferView('close')"></zest-update-loan>
  </div>

  <!-- Confirm Loan cancellation modal -->
  <div id="confirm-cancel-loan" class="modal new-modal" [class.bottom-sheet]="!isDesktop" materialize="modal"
    [materializeParams]="[{dismissible: false}]">
    <form #vouchersCancellationForm="ngForm" name="voucherCancellationForm" id="voucherCancellationForm" method="POST"
      (ngSubmit)="cancelApplications(selectedGCApplications, cancellationReason, otherReason)">
      <div class="modal-content">
        <div class="header">
          <h2 class="title">Cancel Loan?</h2>
          <div class="close-btn" (click)="toggleConfirmCancelLoan('close')">
            <i class="material-icons">close</i>
          </div>
        </div>
        <div>
          Tell us why you don't need this loan anymore
        </div>
        <div class="main-modal-content">
          <div class="radio-container">
            <input id="ProductPriceChanged" type="radio" class="with-gap" [(ngModel)]="cancellationReason"
              name="cancellationReason" [value]="CancellationReasons.ProductPriceChanged"  (click)="trackReason(CancellationReasons.ProductPriceChanged)" />
            <label for="ProductPriceChanged">The price of the product changed</label>
          </div>
          <div class="radio-container">
            <input id="CustomerChangedHisMind" type="radio" class="with-gap" [(ngModel)]="cancellationReason"
              name="cancellationReason" [value]="CancellationReasons.CustomerChangedHisMind"(click)="trackReason(CancellationReasons.CustomerChangedHisMind)" />
            <label for="CustomerChangedHisMind">I changed my mind</label>
          </div>
          <div class="radio-container">
            <input id="ItemOutOfStock" type="radio" class="with-gap" [(ngModel)]="cancellationReason"
              name="cancellationReason" [value]="CancellationReasons.ItemOutOfStock" (click)="trackReason(CancellationReasons.ItemOutOfStock)" />
            <label for="ItemOutOfStock">Product is not available anymore</label>
          </div>
          <div class="radio-container">
            <input id="BadExperience" type="radio" class="with-gap" [(ngModel)]="cancellationReason"
              name="cancellationReason" [value]="CancellationReasons.BadExperience" (click)="trackReason(CancellationReasons.BadExperience)" />
            <label for="BadExperience">I had a bad experience</label>
          </div>
          <div class="radio-container">
            <input id="Other" type="radio" class="with-gap" [(ngModel)]="cancellationReason" name="cancellationReason"
              [value]="CancellationReasons.Other" (change)="checkIfOther()" (click)="trackReason(CancellationReasons.Other)" />
            <label for="Other">Others</label>
          </div>
          <div class="other-reason" *ngIf="cancellationReason === CancellationReasons.Other">
            <div class="input-field">
              <input #other materialize type="text" maxlength="250" minlength="1" autocomplete="off"
                [(ngModel)]="otherReason" id="otherReason" name="otherReason" class="validate" />
              <label for="otherReason">Enter the reason</label>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn zest-btn outline" type="button" (click)="toggleConfirmCancelLoan('close')">NO</button>
        <button class="btn zest-btn primary" type="submit"
          [disabled]="!(cancellationReason && (cancellationReason !==  CancellationReasons.Other || otherReason))">YES,
          CANCEL</button>
      </div>
    </form>
  </div>

  <!-- Confirm Get Voucher modal -->
  <div id="confirm-get-voucher" class="modal new-modal" [class.bottom-sheet]="!isDesktop" materialize="modal"
    [materializeParams]="[{dismissible: false}]">
    <div class="modal-content">
      <div class="header">
        <h2 class="title">Get Voucher</h2>
        <div class="close-btn" (click)="toggleConfirmGetVoucher('close')">
          <i class="material-icons">close</i>
        </div>
      </div>
      <div class="main-modal-content loan-continue">
        <div class="loan-icon">
          <div class='img'
            [style.background-image]="'url(' + s3Url + '/logo-icons/' + (application.MerchantName | lowercase) + '-logo-icon.png)'">
          </div>
        </div>
        <div>
          You will be generating your voucher code(s). Once you get the voucher it cannot be cancelled. This will start
          your
          loan cycle.
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn zest-btn" (click)="generateVoucher(selectedGCApplications)">PROCEED</button>
    </div>
  </div>
</ng-container>

<!-- Card Info -->
<div id="card-info" class="modal new-modal" [class.bottom-sheet]="!isDesktop" materialize="modal">
  <div class="modal-content">
    <div class="header">
      <h2 class="title">What's this?</h2>
      <div class="close-btn" (click)="toggleCardInfo('close')">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="main-modal-content">
      {{loanCard?.cardInfo}}
    </div>
  </div>
</div>

<!-- Referred Card / Insufficient CL / Voucher Genration Failed -->
<div class="new-card primary status-card"
  *ngIf="!showVouchers && (loanCard?.cardType === 3 || loanCard?.cardType === 9 || loanCard?.cardType === 10)">
  <div class='info-icon' *ngIf='loanCard?.cardInfo && (loanCard?.cardType === 9)' (click)="toggleCardInfo('open')">
    <img src='/assets/images/ocd/info-icon.svg' title='Card Info' alt='Card Info' />
  </div>
  <div class="status-info-wrapper">
    <div class="status-icon" [style.background-image]="'url(/assets/images/ocd/' + loanCard.name + '.png)'">
    </div>
    <div class="info-section">
      <h2 class="status-header">{{loanCard.headerText}}</h2>
      <div class="desc">{{loanCard.infoText}}</div>
      <button id="cancel-loan" class="btn zest-btn" *ngIf='(loanCard?.cardType === 9)'
        (click)="redirectToUGC()">PROCEED</button>
    </div>
  </div>
</div>

<!-- Voucher List -->
<zest-voucher-list *ngIf="showVouchers" [vouchers]="generatedGiftCardDetails" [disableCopy]="disableCopy"
  (close)="toggleVouchersView('close')">
</zest-voucher-list>